<template>
  <div class="strikethrough">
    <span
      class="strikethrough__percentage"
      v-if="showPercentage"
      data-testid="strikethrough-percentage"
      :class="getDiscountClass"
    >
      {{ tagDiscount }}
    </span>
    <span class="strikethrough__amount" data-testid="strikethrough-amount">
      <s>{{ formattedAmount }}</s>
      {{ currency }}
    </span>
  </div>
</template>

<script>
import TabTypes from '@/domain/TabTypes'
import { createNamespacedHelpers } from 'vuex'
import { roundPrice } from '@/infrastructure/Utils'
import { isRtl, isRoundedPriceEnabled } from '@/infrastructure/Configuration'

const { mapGetters } = createNamespacedHelpers('multiRoomDisplay')

export default {
  name: 'Strikethrough',
  props: {
    percentageOfDiscount: { type: Number },
    amount: { type: String },
    currency: { type: String },
    showPercentage: {
      type: Boolean,
      default: true
    },
    isCrowdDiscount: { type: Boolean },
    stay: { type: Object },
    tabSelected: String,
    localGroup: { type: Object }
  },
  data: () => ({
    isRoundedPriceEnabled: isRoundedPriceEnabled()
  }),
  computed: {
    ...mapGetters(['getToggleSwitch']),
    formattedAmount() {
      return this.isRoundedPriceEnabled ? roundPrice(parseInt(this.amount)) : this.amount
    },
    getDiscountClass() {
      return this.getToggleSwitch && this.isMirrorMember && this.tabSelected === TabTypes.MEMBER
        ? 'strikethrough__percentage--crowd-member'
        : 'strikethrough__percentage--crowd-public'
    },
    isMirrorMember() {
      return this.localGroup?.hasMemberRates() && this.localGroup?.hasPublicRate()
    },
    tagDiscount() {
      return isRtl()
        ? '-%' + this.percentageOfDiscount.toFixed(0)
        : '-' + this.percentageOfDiscount.toFixed(0) + '%'
    }
  }
}
</script>

<style lang="scss" scoped>
.strikethrough {
  display: flex;
  align-items: center;
  margin-bottom: 0.4rem;

  &__percentage {
    color: white;
    font-weight: 700;
    white-space: nowrap;
    font-size: 1.2rem;
    border-radius: 4px;
    padding: 0px 6px;
    margin-right: 0.5rem;
    &--crowd-member {
      background-color: #382246;
    }
    &--crowd-public {
      background-color: #50b065;
    }
  }

  &__amount {
    display: flex;
    flex-wrap: nowrap;
    color: #97999b;
    font-weight: initial;
    font-size: 1.4rem;

    s {
      margin-left: 0.25rem;
      margin-right: 0.25rem;
    }
  }
}
</style>
